import styled, { css } from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

export const Container = styled.div`
  ${() => css`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding-bottom: 1.25rem;

    > img {
      width: 2.25rem;
      height: 2.25rem;
      flex-shrink: 0;
    }
  `}
`;

export const InputBox = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    align-items: center;
    background: ${theme.colors.background[80]};
    border: 1.5px solid ${theme.colors.base.border};
    border-radius: 9999px;
    padding: 0 0.375rem 0 1rem;
    transition: ${theme.transition.default};

    :focus-within {
      border-color: ${theme.colors.brand.primary.default};
      background: ${theme.colors.background[100]};
      box-shadow: 0 0 0 3px ${theme.colors.brand.primary.opaque};
    }
  `}
`;

export const AutosizeInput = styled(TextareaAutosize)`
  ${({ theme }) => css`
    flex: 1;
    border: none;
    outline: none;
    font-size: 0.875rem;
    color: ${theme.colors.foreground[100]};
    padding: 0.625rem 0;
    resize: none;
    background: transparent;
    min-height: unset;

    ::placeholder {
      color: ${theme.colors.foreground[40]};
    }
  `}
`;

export const EmojiButton = styled.button`
  ${({ theme }) => css`
    width: 2rem;
    height: 2rem;
    border-radius: 9999px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${theme.colors.foreground[40]};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.opaque};
      color: ${theme.colors.brand.primary.default};
    }
  `}
`;

export const PickerWrapper = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.base.border};
    border-radius: 0.75rem;
    box-shadow: ${theme.shadows.lg};
    overflow: hidden;

    .epr-main {
      border: none;
    }
  `}
`;

export const SendButton = styled.button`
  ${({ theme }) => css`
    width: 2rem;
    height: 2rem;
    border-radius: 9999px;
    border: none;
    background: ${theme.colors.brand.primary.default};
    color: ${theme.colors.brand.primary.text};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.hover};
      transform: scale(1.05);
    }
  `}
`;
